<div class="nav-icon-container" role="button" [id]="idKey" aria-pressed="false" [class.icon-hover]="isActive"
  [ngClass]="{ 'fixed-width': hasFixedWidth, 'disabled' : isDisabled}" aria-label="Navigation Icon"
  (click)="selectIcon(idKey)">
  @if (iconName) {
    <mat-icon [fontSet]="isOutlined ? 'material-icons-outlined': ''"
    [class.icon-active]="isActive">{{iconName}}</mat-icon>
  }
  @if (textLabel) {
    <span class="icon-label">
      {{textLabel | translate}}
    </span>
  }
</div>